<script>
export let data;
</script>

<div>
{@html data.props.html}
</div>